import { Box, ListItem } from "arkh";
import { OrgSearchInput } from "../../OrgSearchInput";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { SortableColumnTitle } from "../../SortableColumnTitle";
import { WorkspaceSignalStoreItemContainer } from "./WorkspaceSignalStoreItemContainer";

export type WorkspaceSignalOrderByKey = "store" | "seen";
type WorkspaceSignalOrder = {
  column: WorkspaceSignalOrderByKey;
  order: "ASC" | "DESC";
};
export function WorkspaceSignalListHeader(props: {
  setOrderBy: (_: WorkspaceSignalOrder) => void;
  order: WorkspaceSignalOrder;
  search: string;
  setSearch: (search: string) => void;
}) {
  const sortableProp = (key: WorkspaceSignalOrderByKey) => ({
    order: props.order.column === key ? props.order.order : null,
    onOrderBySelect: () =>
      props.setOrderBy({
        column: key,
        order: "DESC",
      }),
    onOrderChange: (order: "ASC" | "DESC") =>
      props.setOrderBy({ column: key, order }),
  });

  const intl_tokens = useIntlTokens();
  return (
    <Box color="surface-background-light">
      <OrgSearchInput value={props.search} onChangeText={props.setSearch} />
      <ListItem disabled border="border-primary" displayMode="TABLE">
        <WorkspaceSignalStoreItemContainer
          storeName={
            <>
              <SortableColumnTitle
                {...sortableProp("store")}
                title={intl_tokens.Name}
              />
            </>
          }
          seen={
            <>
              <SortableColumnTitle
                {...sortableProp("seen")}
                title={intl_tokens.Opened}
              />
            </>
          }
        />
      </ListItem>
    </Box>
  );
}
